import React, {useEffect, useState} from 'react';
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import PaginationBar from "../../../../../components/PaginationBar";
import {useIntl} from "react-intl";
import {PaginationDto} from "../../../../../modules/common/dto/PaginationDto";
import {RequestVisitorSearchCondition} from "../../../../../modules/vms/dto/RequestVisitorSearchCondition";
import {RequestVisitorApi} from "../../../../../modules/vms/api/RequestVisitorApi";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import SearchCondition from "./components/SearchCondition";
import SearchResult from "./components/SearchResult";
import {Grid, Paper} from "@mui/material";
import {VisitRequestClassify} from "../../../../../modules/vms/enums/VisitRequestClassify";
import PageTitle from "../../../../../components/PageTitle";

const Index: React.FC = () => {

    const intl = useIntl();

    // 查询条件
    const [searchCondition, setSearchCondition] = useState(new RequestVisitorSearchCondition());

    // 查询结果
    const [searchResult, setSearchResult] = useState(new Array<RequestVisitorDto>());

    // 分页数据
    const [pagination, setPagination] = useState(new PaginationDto());
    useEffect(() => {
    }, []);
    useEffect(() => {
        const searchCondition = new RequestVisitorSearchCondition();
        searchCondition.requestClassify = VisitRequestClassify.Enum.Shipping;
        setSearchCondition(searchCondition);
        handleSearch(searchCondition);
    }, []);

    const handleChangeCondition = (name: string, value: any) => {
        setSearchCondition({...searchCondition, [name]: value});
    };

    const handleSearch = async (searchCondition: RequestVisitorSearchCondition) => {
        const responseResult = await RequestVisitorApi.queryRequestVisitors(searchCondition);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setSearchResult(responseResult.data);
            setPagination(responseResult.pagination);
        }
    };

    const handleSearchReport = async (searchCondition: RequestVisitorSearchCondition) => {
        await RequestVisitorApi.queryRequestVisitorsReport(searchCondition, VisitRequestClassify.Enum.Shipping);
    };

    const handlePagination = (page: number, pageSize: number) => {
        const newSearchCondition = Object.assign({}, searchCondition);
        newSearchCondition.currentPage = page;
        newSearchCondition.pageSize = pageSize;
        handleSearch(newSearchCondition);
    };

    return (
        <div>
            <PageTitle title={intl.formatMessage({id: 'VMS_VISIT_REQUEST_CLASSIFY_SHIPPING'})}/>
            <Paper sx={{p: 1}}>
                <SearchCondition searchCondition={searchCondition}
                                 onChange={handleChangeCondition}
                                 onSearch={() => handleSearch(searchCondition)}
                                 onSearchReport={() => handleSearchReport(searchCondition)}/>
            </Paper>

            <br/>

            <Paper sx={{p: 1}}>
                <Grid container columnSpacing={2} alignItems="center">

                    <Grid item xs={10}> <PaginationBar pagination={pagination} onChange={handlePagination}
                    /></Grid>
                    <Grid item xs
                          style={{textAlign: "right"}}>{intl.formatMessage({id: "VMS_VISIT_REQUEST_VISITOR_COUNT"})} : {pagination.recordSum}</Grid></Grid>
                <SearchResult searchResult={searchResult}

                              onSortSearch={(
                                  sortField, sortBy
                              ) => {
                                  const newSearchCondition = Object.assign({}, searchCondition);
                                  newSearchCondition.sortField = sortField;
                                  newSearchCondition.sortType = sortBy;
                                  setSearchCondition(newSearchCondition)
                                  handleSearch(newSearchCondition)
                              }}/>
            </Paper>
        </div>
    );
};

export default Index;
